import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M24.29 40.71c.39.39 1.02.39 1.41 0l10-10a.996.996 0 1 0-1.41-1.41L26 37.59V5c0-.55-.45-1-1-1s-1 .45-1 1v32.59l-8.29-8.29a.996.996 0 0 0-1.7.71c0 .26.1.51.29.71l10 10ZM38.5 44h-27c-.83 0-1.5.45-1.5 1s.67 1 1.5 1h27c.83 0 1.5-.45 1.5-1s-.67-1-1.5-1",
      style: {"fill":"#999","stroke-width":"0"}
    }, null, -1)
  ])))
}
export default { render: render }